import InlineEditableLogo from './InlineEditableLogo'

export default InlineEditableLogo
